module.exports = __webpack_public_path__ + "img/jbqk-bg.7f5ec3a2.jpg";